// extracted by mini-css-extract-plugin
var _1 = "ShortcutSection-module__container--prkw_";
var _2 = "ShortcutSection-module__header--siIx9";
var _3 = "ShortcutSection-module__table--vUVlU";
export { _1 as "container", _2 as "header", _3 as "table" }
